(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
    		'ui.sortable'
    		, 'ngFileUpload'
      , 'vkEmojiPicker'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('TriggersController', trigger);

  trigger.$inject = ['$rootScope', '$scope', '$http', '$state', 'NotificationFactory', 'Upload', '$sce', 'StatusService', 'ChannelManager', 'WhiteListService'];

  function trigger ($rootScope, $scope, $http, $state, NotificationFactory, Upload, $sce, StatusService, ChannelManager, WhiteListService) {
    	var vm = this;

 		var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vm.sortableOptions = {
      containment: '#sortable-container'
    };
    vm.addTrigger = addTrigger;
    vm.addTriggerAction = addTriggerAction;
    vm.saveTriggerOther = saveTriggerOther;
    vm.saveTriggerText = saveTriggerText;
    vm.removeAction = removeAction;
    vm.deleteTrigger = deleteTrigger;
    vm.showEmoji = $rootScope.user_data.settings.show_emoticons;

    	var url = apiUrl + '/channels/get-triggers/{channel_type}/{channel_id}';
    $http.get(url.replace('{channel_type}', $state.params.type).replace('{channel_id}', $state.params.id))
      .then(function ({ data, status, headers, config }) {
            	if (data.success) {
            		vm.channel_data = data.channel_data;
            		angular.forEach(data.triggers, function (value, key) {
            if (key == 'before_working_period' || key == 'after_working_period') {
              if (value.monday_to_friday) {
                value.monday_to_friday = new Date(value.monday_to_friday);
              }
              if (value.saturday) {
                value.saturday = new Date(value.saturday);
              }
              if (value.sunday) {
                value.sunday = new Date(value.sunday);
              }
            }
          });
            		vm.triggers = data.triggers;

            		if (!vm.triggers.hasOwnProperty('offline_operators_notification')) {
            vm.triggers.offline_operators_notification = { text: '', params: { active: true } }
          } else if (!vm.triggers.offline_operators_notification.hasOwnProperty('params') ||
						vm.triggers.offline_operators_notification.params == null) {
            vm.triggers.offline_operators_notification.params = { active: true };
          } else if (!vm.triggers.offline_operators_notification.params.hasOwnProperty('active')) {
            vm.triggers.offline_operators_notification.params.active = true;
          }
            	} else {
            		vm.channel_data = null;
            		vm.triggers = null;
            	}
      }, function (error) { console.log(error) });

       	StatusService.all()
	        .$promise
	        .then(function (data) {
	            vm.statuses = data;
	        }).catch(function (data) {
	            errorHandler(data, $scope.labels.trigErrorUploadStatus)
	        })

    WhiteListService.getByChannelId(
        	{
        		channel_id: $state.params.id,
        		channelable_type: $state.params.type
        	})
	        .$promise
	        .then(function (data) {
	        	vm.whiteListsCount = data.length;
	        }).catch(function (data) {
	            errorHandler(data, $scope.labels.trigErrorLoadWhiteLists)
        	})

    function successHandler (data, override_message) {
      var message = $scope.labels.trigDataSaveSuccess;
      if (override_message) {
            	message = override_message;
      } else {
            	if (data && data.data && data.data.message) {
          message = data.data.message;
	            }
      }
         	notifSet.addNotification({ title: $scope.labels.TriggerSuccess, content: message, autoclose: '3000', color: 'success' });
    }
    function errorHandler (data, override_message) {
      var message = $scope.labels.trigErrorTryAgain;
      if (override_message) {
            	message = override_message;
      } else if (data && data.data && data.data.message) {
        message = data.data.message;
      }
         	notifSet.addNotification({ title: $scope.labels.triggerError, content: message, autoclose: '3000', color: 'alert' });
    }

    function addTrigger (trigger) {
      vm.triggers.text.push({ name: $scope.labels.triggerNew, trigger_type: 'text', actions: [] });
    }
    function addTriggerAction (trigger) {
      trigger.actions.push({ type: '', params: {} });
    }
    function saveTriggerOther () {
      var url = apiUrl + '/channels/save-triggers-others/{channel_type}/{channel_id}';
      var data = {
        first_message: vm.triggers.first_message,
        invalid_command: vm.triggers.invalid_command,
        offline_operators_notification: vm.triggers.offline_operators_notification,
        menu: vm.triggers.menu,
        before_working_period: angular.copy(vm.triggers.before_working_period),
        after_working_period: angular.copy(vm.triggers.after_working_period),
        white_list: vm.triggers.white_list
      };

      angular.forEach(data, function (value, key) {
        if (key == 'before_working_period' || key == 'after_working_period') {
          if (typeof value !== 'undefined') {
            if (value.hasOwnProperty('monday_to_friday')) {
              if (value.monday_to_friday != null) {
                value.monday_to_friday = moment(value.monday_to_friday).format('HH:mm');
              } else {
                delete value.monday_to_friday;
              }
            }
            if (value.hasOwnProperty('saturday')) {
              if (value.saturday != null) {
                value.saturday = moment(value.saturday).format('HH:mm');
              } else {
                delete value.saturday;
              }
            }
            if (value.hasOwnProperty('sunday')) {
              if (value.sunday != null) {
                value.sunday = moment(value.sunday).format('HH:mm');
              } else {
                delete value.sunday;
              }
            }
          }
        }
      });

      $http.post(url.replace('{channel_type}', $state.params.type).replace('{channel_id}', $state.params.id), data)
        .then(function ({ data }) {
          successHandler(data, $scope.labels.TriggersSaveSuccess);
        }, function ({ data }) {
          errorHandler(data, $scope.labels.triggerSaveError);
        })
    }
    function saveTriggerText (trigger) {
      var url = apiUrl + '/channels/save-triggers-text/{channel_type}/{channel_id}';
      var data = trigger;
      function validateTrigger (trigger) {
        var name = trigger.name.trim();
        var trigger_text = (trigger.trigger_text) ? trigger.trigger_text.trim() : '';
        if (name.length == 0) {
          errorHandler(null, $scope.labels.triggerRequiredName);
          return false;
        }
        if (trigger_text.length == 0) {
          errorHandler(null, $scope.labels.triggerRequiredClient);
          return false;
        }
        if (name.length > 120) {
          errorHandler(null, $scope.labels.triggerNameLimit);
          return false;
        }
        if (trigger_text.length > 255) {
          errorHandler(null, $scope.labels.triggerClientLimit);
          return false;
        }
        var chat_count = 0;
        var quitchat_count = 0;
        var content_count = 0;
        var exit_chat_count = 0;
        for (var i = 0; i < trigger.actions.length; ++i) {
          var action = trigger.actions[i];
          if (action.type == 'CHAT') {
            ++chat_count;
          }
          if (action.type == 'QUIT_CHAT') {
            ++quitchat_count;
            if (content_count > 0) {
              errorHandler(null, $scope.labels.triggerEndChatError);
              return false;
            }
          }
          if (action.type == 'TEXT') {
            var text = (action.params && action.params.text) ? action.params.text.trim() : '';
            if (text.length == 0) {
              errorHandler(null, $scope.labels.triggerRequiredText);
              return false;
            }
            if (chat_count > 0) {
              errorHandler(null, $scope.labels.triggerTextError);
              return false;
            }
            ++content_count;
          }
          if (action.type == 'EXIT_CHAT') {
            if (action.params.status_id == undefined || action.params.status_id == '' || action.params.status_id == null) {
              errorHandler(null, $scope.labels.trigEndRequiredStatus);
              return false;
            }
            ++exit_chat_count;
          }
          if (action.type == 'MEDIA') {
            var text = (action.params && action.params.media && action.params.media.public_path) ? action.params.media.public_path.trim() : '';
            if (text.length == 0) {
              errorHandler(null, $scope.labels.trigFileRequired);
              return false;
            }
            if (chat_count > 0) {
              errorHandler(null, $scope.labels.trigMediaError);
              return false;
            }
            ++content_count;
          }
        }
        if (chat_count > 1) {
          errorHandler(null, $scope.labels.trigErrorLimitStart);
          return false;
        }
        if (quitchat_count > 1) {
          errorHandler(null, $scope.labels.trigErrorLimitEndOp);
          return false;
        }
        if (exit_chat_count > 1) {
          errorHandler(null, $scope.labels.trigErrorLimitEnd);
          return false;
        }
        if (chat_count >= 1 && quitchat_count >= 1) {
          errorHandler(null, $scope.labels.trigErrorStartEnd);
          return false;
        }
        return true;
      }
      var valid = validateTrigger(trigger);
      if (!valid) { return; }
      $http.post(url.replace('{channel_type}', $state.params.type).replace('{channel_id}', $state.params.id), data)
        .then(function ({ data }) {
          if (data.success) {
            trigger.id = data.trigger.id;
            trigger.triggerable_id = data.trigger.triggerable_id;
            trigger.triggerable_type = data.trigger.triggerable_type;
          }
          successHandler(data, $scope.labels.triggerSaveSuccess);
        }, function (error) {
          errorHandler(error, $scope.labels.triggerSaveError);
        })
    }
    function removeAction (trigger, index) {
      trigger.actions.splice(index, 1);
    }
    function deleteTrigger (trigger, index) {
      var url = apiUrl + '/channels/delete-trigger/{trigger_id}';
      $http.post(url.replace('{trigger_id}', trigger.id), { '_method': 'delete' })
        .then(function ({ data }) {
          if (data.success) {
            vm.triggers.text.splice(index, 1);
            successHandler(data, $scope.labels.triggerDeleteSuccess);
          } else {
            errorHandler(data, $scope.labels.triggerDeleteError);
          }
        }, function (error) {
          errorHandler(error, $scope.labels.triggerDeleteError);
        })
    }

    vm.checkAttaching = function (action, stage) {
      action.temp = action.temp || {};
      if (action.params.media) {
        action.temp.attachState = 3;
      }
      var current = action.temp.attachState || 1;
      if (stage) {
        return current == stage;
      }
      return current > 1;
    }
    vm.cancelAttach = function (action) {
      action.temp.attachState = 1;
    }
    vm.upload = function (file, action) {
      if (!file) return;

      action.temp.attachState = 2;
      vm.current_progress = 0;
      Upload.upload({
        url: baseUrl + '/channel/trigger_image',
        fields: { 'channel_id': $state.params.id, 'channel_type': $state.params.type },
        file: file
      }).progress(function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        vm.current_progress = progressPercentage;
      }).then(function (data, status, headers, config) {
        if (data.success) {
          action.temp.attachState = 3;
          action.params.media = data.media;
        }
      }, function (data, status, headers, config) {
        errorHandler(data, $scope.labels.triggerUploadError)
      })
    };
    vm.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    }
    vm.backToList = function () {
        	if ($state.params.type == 'wwpp') {
            	$state.go('main.whatsapp', { id: $rootScope.user_data.company_id });
        	}
        	ChannelManager.backToList($state, $rootScope.user_data.company_id);
    }

    vm.setFirstMessageAction = function () {
      if (vm.triggers.first_message.text && vm.triggers.first_message.start_chat !== '1') {
        vm.triggers.first_message.start_chat = '0';
      }
    }
  }
})();
